import { render } from "./StoreTransferRegisterView.vue?vue&type=template&id=a8ff4fa4&scoped=true"
import script from "./StoreTransferRegisterView.vue?vue&type=script&lang=js"
export * from "./StoreTransferRegisterView.vue?vue&type=script&lang=js"

import "./StoreTransferRegisterView.vue?vue&type=style&index=0&id=a8ff4fa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ff4fa4"]])

export default __exports__